import { render, staticRenderFns } from "./DataListCharact.vue?vue&type=template&id=bae89c9e"
import script from "./DataListCharact.vue?vue&type=script&lang=js"
export * from "./DataListCharact.vue?vue&type=script&lang=js"
import style0 from "./DataListCharact.vue?vue&type=style&index=0&id=bae89c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports